import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      // Check for updates every hour
      if (r) {
        setInterval(() => r.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-xl border border-border bg-card p-4 shadow-lg animate-slide-in-up">
      <RefreshCw className="h-5 w-5 text-primary" />
      <div>
        <p className="text-sm font-medium">Nueva versión disponible</p>
        <Button
          size="sm"
          className="mt-1 h-7 text-xs"
          onClick={() => updateServiceWorker(true)}
        >
          Actualizar ahora
        </Button>
      </div>
    </div>
  );
}
